var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"color":"primary","dark":"","elevation":12}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.pageTitle))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }